import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const solutionBlocks = [
  {
    title: "High-Volume Hiring",
    description:
      "Scale sourcing, screening, and candidate evaluation across large hiring programs without sacrificing candidate quality or recruiter efficiency.",
  },
  {
    title: "Specialized Roles",
    description:
      "Prioritize niche technical, leadership, and domain-specific talent using AI-assisted candidate scoring and intelligent shortlisting.",
  },
  {
    title: "Contractor & Vendor Programs",
    description:
      "Manage contractor hiring and vendor-supplied talent through a unified workflow with transparent collaboration and performance tracking.",
  },
  {
    title: "Global Talent Operations",
    description:
      "Coordinate hiring signals, approvals, and candidate pipelines across distributed hiring teams and multiple geographic regions.",
  },
];

export const SolutionsPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-20 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Solutions
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          Hiring Solutions for Every Growth Stage
        </h1>

        <p className="mt-6 max-w-3xl text-[#D9E1E8]/80 text-lg">
          The AI Matters platform supports organizations at every stage of
          growth—from early-stage startups to global enterprises. Our
          AI-powered hiring infrastructure helps companies scale talent
          acquisition while maintaining quality, speed, and transparency.
        </p>
      </section>


      {/* SOLUTION CARDS */}
      <section className="grid gap-6 md:grid-cols-2">

        {solutionBlocks.map((item) => (
          <Card
            key={item.title}
            className="border-white/10 bg-[#0B253C]/60"
          >
            <CardHeader>
              <CardTitle className="text-xl">
                {item.title}
              </CardTitle>
            </CardHeader>

            <CardContent>
              <p className="text-[#D9E1E8]/80">
                {item.description}
              </p>
            </CardContent>
          </Card>
        ))}

      </section>


      {/* USE CASE SECTION */}
      <section>

        <h2 className="text-3xl font-bold mb-6">
          Designed for Modern Talent Teams
        </h2>

        <p className="max-w-4xl text-[#D9E1E8]/80">
          Traditional hiring systems often struggle to keep up with the
          pace of modern business growth. The AI Matters platform provides
          structured hiring infrastructure that connects recruiters,
          hiring managers, and candidate pipelines in one unified system.
        </p>

        <p className="mt-4 max-w-4xl text-[#D9E1E8]/80">
          By combining AI-powered candidate evaluation, recruiter
          collaboration, and transparent hiring workflows, organizations
          can make faster and more consistent hiring decisions across
          teams and geographies.
        </p>

      </section>


      {/* CTA */}
      <section className="glass-panel rounded-2xl p-10 text-center">

        <h2 className="text-3xl font-bold mb-4">
          Discover the Right Hiring Solution
        </h2>

        <p className="max-w-2xl mx-auto text-[#D9E1E8]/80 mb-6">
          Whether you're scaling a startup team or managing enterprise
          hiring programs, The AI Matters platform provides the tools
          needed to build efficient and data-driven hiring operations.
        </p>

        <button className="rounded-full bg-[#2EC4A6] px-8 py-3 font-semibold text-[#071A2C] hover:bg-[#6FE3C1]">
          Request a Platform Demo
        </button>

      </section>

    </div>
  );
};